// LOCAL / QA ONLY. When true, the client treats the signed-in user as
// unmetered for AI + downloads so you can exercise flows without burning
// the free/paid counter. Production builds must keep this false/unset —
// nobody else is unlimited (paid = 500/period, free = 15 lifetime).
//
// Note: live Cloud Functions still enforce free/paid caps. For true unmetered
// local API tests, point at the functions emulator or a test project.

const truthy = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();
  return normalized === "true" || normalized === "1" || normalized === "yes";
};

export const isAllowAllFeatureByDev = () =>
  truthy(process.env.REACT_APP_IS_ALLOW_ALL_FEATURE_BY_DEV);

export default { isAllowAllFeatureByDev };
